import { toast } from '@/hooks/use-toast'

export interface ApiError {
  message: string
  code?: string
  status?: number
}

export function handleApiError(error: unknown): string {
  if (error instanceof Error) {
    return error.message
  }

  if (typeof error === 'string' && error) {
    return error
  }
  
  if (typeof error === 'object' && error !== null) {
    const apiError = error as ApiError
    if (apiError.message) {
      return apiError.message
    }
  }
  
  return 'An unexpected error occurred'
}

export function showErrorToast(error: unknown, customMessage?: string) {
  const fullMessage = customMessage || handleApiError(error)
  // Truncate very long messages for toast display
  const message = fullMessage.length > 200
    ? fullMessage.substring(0, 200) + '...'
    : fullMessage

  // Log error details for debugging (only in development)
  if (process.env.NODE_ENV === 'development') {
    console.error('Error toast:', error instanceof Error ? error : fullMessage)
  }

  toast({
    variant: 'destructive',
    title: 'Error',
    description: message,
  })
}

export function showSuccessToast(message: string) {
  toast({
    title: 'Success',
    description: message,
  })
}
